export interface IIcon {
    name: number;
    value: string;
}

class Icons {
    public _IconMap: Map<number, string>;
    public defaultIco = 'SimpleYellowCar.svg';

    constructor() {
        this._IconMap = new Map();
        this._setMap();
    }

    public _setMap() {
        this._IconMap.set(1, 'SimpleYellowCar.svg');
        this._IconMap.set(2, 'simple-travel-car.svg');
        this._IconMap.set(3, 'SimpleDarkBlueCar.svg');
        this._IconMap.set(4, 'SimpleGreenCar.svg');
        this._IconMap.set(5, 'SimpleOrangeCar.svg');
        this._IconMap.set(6, 'SimplePurpleCar.svg');
        this._IconMap.set(7, 'truck_1.png');
        this._IconMap.set(8, 'motorbike_1.svg');
    }

    public getIcon(number: number) {
        const fileName = this._IconMap.get(number);
        return fileName ?? this.defaultIco;
    }

    public get iconList(): IIcon[] {
        return Array.from(this._IconMap, ([name, value]) => ({ name, value }));
    }
}

const icons = new Icons();

export default icons;
